import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import Loader from "../components/Loader";

const Refund_And_Cancellation_Policy = () => {
    const [loading, setLoading] = useState(true);
    const [privacyPolicy, setPrivacyPolicy] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, [privacyPolicy]);


    useEffect(() => {
        const fetchTrendingStyle = async () => {
            try {
                const response = await axiosInstance.get('/cms-page/privacy_policy');
                if (response.data.success) {
                    console.log(response.data.cmspage);
                    setPrivacyPolicy(response.data.cmspage || []);
                }else{
                    setError('Failed to load pages');
                }
            } catch (error) {
                console.error("Error fetching trending styles:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchTrendingStyle();
    }, []);

    if (loading) {
        return <Loader />
    }

    if (error) {
        return <div>{error}</div>;
    }
    return (
        privacyPolicy.map((item, index) => {
            const firstImageUrl =item.profile_img_url[0] || '';
            console.log('First Image URL:', item.profile_img_url[0]);
            return (
                <>
                    <Meta title="Privacy Policy - THE CUTTING BAR" />
                    <PageBanner imageUrl={firstImageUrl || 'assets/images/background/3.jpg'} heading={item.section_title || 'Privacy Policy'} />
                    <section key={index} aria-label="Privacy Policy" className="no-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="wow fadeInRight" data-wow-delay=".4s">
                                        <div
                                            className="vision-mission-description"
                                            dangerouslySetInnerHTML={{ __html: item.description || 'No description available.' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            );
        })
    )
}

export default Refund_And_Cancellation_Policy;
